"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideAllBars = exports.hideBar = exports.showNotification = exports.showMessage = exports.showHint = exports.showSuccess = exports.showError = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var constants = _interopRequireWildcard(require("./notification-bar-constants"));

var show = function show(message, type, target) {
  var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 6000;
  var callback = arguments.length > 4 ? arguments[4] : undefined;
  return function (dispatch) {
    // Create a new notification to display.
    var id = new Date().getTime();
    dispatch({
      type: constants.SHOW,
      payload: {
        id: id,
        type: type,
        message: message,
        target: target,
        callback: callback
      }
    }); // After the timeout period (6s) automatically close the notification.

    setTimeout(function () {
      dispatch({
        type: constants.HIDE,
        id: id,
        callback: callback
      });
    }, timeout);
  };
};

var showError = function showError(message, target, timeout, callback) {
  return show(message, 'error', target, timeout, callback);
};

exports.showError = showError;

var showSuccess = function showSuccess(message, target) {
  return show(message, 'success', target);
};

exports.showSuccess = showSuccess;

var showHint = function showHint(message, target) {
  return show(message, 'hint', target);
};

exports.showHint = showHint;

var showMessage = function showMessage(message, target) {
  return show(message, 'neutral', target);
};

exports.showMessage = showMessage;
var showNotificationShape = {
  icon: _propTypes["default"].oneOf([_propTypes["default"].string, _propTypes["default"].node]),
  message: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  variant: _propTypes["default"].oneOf(['default', 'alert', 'error', 'success']),
  target: _propTypes["default"].oneOf(['fullscreen', 'wizard', 'page']),
  button: _propTypes["default"].node,
  onClose: _propTypes["default"].func,
  timeout: _propTypes["default"].number
};

var showNotification = function showNotification(options) {
  return function (dispatch) {
    _propTypes["default"].checkPropTypes(showNotificationShape, options, 'option', 'notification-bar-actions.showNotification'); // Create a new notification to display.


    var id = new Date().getTime();
    var timeout = options.timeout || 6000;
    dispatch({
      type: constants.SHOW,
      payload: (0, _objectSpread2["default"])({}, options, {
        callback: options.onClose,
        version: 2,
        id: id
      })
    });
    setTimeout(function () {
      dispatch({
        type: constants.HIDE,
        id: id,
        callback: options.onClose
      });
    }, timeout);
    return id;
  };
};

exports.showNotification = showNotification;

var hideBar = function hideBar(id) {
  return function (dispatch) {
    // Stop duplicate actions from being dispatched.
    dispatch({
      type: constants.HIDE,
      id: id
    });
  };
};

exports.hideBar = hideBar;

var hideAllBars = function hideAllBars() {
  return function (dispatch) {
    // Stop duplicate actions from being dispatched.
    dispatch({
      type: constants.HIDE_ALL
    });
  };
};

exports.hideAllBars = hideAllBars;